import styled from 'styled-components'

export const LogoutContainer = styled.div`
  margin-top: 1rem;
  text-align: center;
`
